import React from 'react'
import {useTranslation} from 'react-i18next'

import {Avatar, Stack, Typography} from '@mui/material'

import {ReactComponent as ThumbUp} from '@progyny/assets/images/thumbs-up.svg'
import ContactSupport from '@progyny/components/ContactSupport'

const RejectedAgreement = () => {
  const {t} = useTranslation()
  return (
    <>
      <Stack mt={10} alignItems={'center'} justifyContent={'center'}>
        <Avatar
          sx={{
            width: 110,
            height: 110,
            bgcolor: '#EEEEF1',
            position: 'relative',
            mb: 4,
          }}
        >
          <ThumbUp />
        </Avatar>
        <Typography mt={4} fontSize={24} fontWeight={600}>
          {t('partners_agreement_rejected_agreement_we_ve_noted_your_response')}
        </Typography>
        <Typography my={2} fontSize={18} fontWeight={400}>
          {t('partners_agreement_rejected_agreement_you_ve_chosen_not_to')}
        </Typography>
        <Typography
          textAlign={'center'}
          width={'29%'}
          fontSize={18}
          fontWeight={400}
        >
          {t(
            'partners_agreement_rejected_agreement_our_team_has_been_notified'
          )}
        </Typography>
      </Stack>
      <ContactSupport
        textKey='partners_agreement_rejected_agreement_if_you_would_please_reach'
        px='6rem'
        mt={16}
      />
    </>
  )
}

export default RejectedAgreement
